import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import ImageCard from "../ImageCard/ImageCard.js";
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

function ImageStepper(props) {
  const theme = useTheme();
  const steps = props.steps;
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    [
      <Paper square elevation={0} sx={{display: 'flex', alignItems: 'center', pl: "5%", pr: "5%", pt:"5%", pb:"5%", height: "100%", backgroundColor:"rgba(7, 7, 7, 0.84)", borderRadius:"8px", pointerEvents: "none"}}>
        <ImageCard maxWidth={"100%"} height={"inherit"} alt={"ImpureChess_ScreenShot" + steps} img={steps[activeStep].img}/>,
      </Paper>,
      <MobileStepper variant="dots" steps={maxSteps} position="static" activeStep={activeStep} sx={{ maxWidth: "100%", flexGrow: 1, bgcolor: "rgba(7, 7, 7, 0.84)", borderRadius: "8px",
          '.MuiMobileStepper-dot': {
            backgroundColor: 'grey', // Inactive dot color
          },
          '.MuiMobileStepper-dotActive': {
            backgroundColor: 'white', // Active dot color
          },
          '.MuiMobileStepper-': {

          }}}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1} sx={{color: "#ffffff", bgcolor: "rgba(0, 0, 0, 0)"}} >
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={{color: "#ffffff", bgcolor: "rgba(0, 0, 0, 0)"}}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </Button>
        }
      />
    ]
  );
}

export default ImageStepper;